<template>
  <div class="drlyTrends">
    <div
      class="headImg"
      :style="{
        width: '100%',
        backgroundImage: 'url(' + require('@/assets/trends/head.png') + ')',
        backgroundSize: '100% 100%',
      }"
    >
      <div class="head_body">
        <div class="head_title">资讯动态</div>
        <img :src="require('@/assets/trends/more.png')" />
      </div>
    </div>
    <div class="body">
      <div class="menu">
        <div
          :class="active == '全部' ? 'menu_item active' : 'menu_item'"
          @click="
            () => {
              active = '全部';
            }
          "
        >
          全部
        </div>
        <!-- <div
          :class="active == '1' ? 'menu_item active' : 'menu_item'"
          @click="clickTag(1)"
        >{{getTagText(1)}}</div> -->
      </div>
      <div class="content">
        <card
          v-for="c in trendsData"
          :key="c.guid"
          :data="c"
        />
      </div>
    </div>
  </div>
</template>

<script>
import card from "../../components/trends/card.vue";
export default {
  name: "DrlyTrends",
  components: {
    card,
  },
  props: {},
  data() {
    return {
      active: "全部",
      trendsData: [
        {
          "guid": "1851193389484085250",
          "title": "商家如何通过调查抓牢消费动线中的“触点”？",
          "trendsDesc": "对餐饮和零售企业来说，门店的消费动线是提升服务质量、优化空间布局和增加顾客满意度的关键步骤。无论店型大小，都离不开合理的动线设计。依托于丰富多样的新技术新手段，经营者能从数据层面获取大量的动线优化依据，而大人来也顾客体验式调查，除了满足经营者对门店运营质量的需求，也有助于持续监测消费动线的合理性，尤其是牵涉到人员介入的消费“触点”，帮助企业更好地理解顾客需求。",
          "trendsGuid": "1851193389484085250",
          "headImage": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-29/image/41182bc56579e78247808c85029d1a5b.png",
          "headImageMax": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-29/image/1009a2675d49985ef6babc54fc770aa1.png",
          "headImageMin": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-29/image/fbce9e0286b8dad5c414830f3e9aff74.png",
          "contentLink": "https://mp.weixin.qq.com/s/2_FbPB2Wl3owjb_ijlcDiA",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-10-27T09:24:32.000+00:00",
          "updateTime": "2024-10-27T09:24:32.000+00:00",
          "sort": 1
        },
        {
          "guid": "1848293851597377538",
          "title": "当我们在审核报告时，我们在审核什么？",
          "trendsDesc": "无论评估员还是商户，经常会问我们：你们的问卷报告需要后台审核，请问审核标准是什么？这篇文章就来回答这个问题。",
          "headImage": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-21/image/d3371988acee476df15e8a7621c09c4a.png",
          "headImageMax": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-21/image/fbc573d55ee73d6ca11e9afae7f8ea19.png",
          "headImageMin": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-21/image/c5281521b2531d875c2c427195b9114a.png",
          "contentLink": "https://mp.weixin.qq.com/s/KlkoKKYB2U1zT_ez7Csv2Q",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-10-20T09:22:49.000+00:00",
          "updateTime": "2024-10-21T09:22:49.000+00:00"
        },
        {
          "guid": "1848548077502205953",
          "title": "当执行探店任务时，你该注意什么？",
          "trendsDesc": "评估员们，你是否碰到过在执行任务时神色慌张，填写问卷时手忙脚乱，提交问卷后因回答不完整，缺少重要照片凭证而问卷打回...如果有这些情况，请认真看一下本篇探店执行指南。",
          "headImage": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-22/image/7c6523aadab9a1c413dc43879bbaba29.png",
          "headImageMax": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-22/image/cc32071ecd3d2902fe7888b37d352a1d.png",
          "headImageMin": "http://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-22/image/99215dc5985204b73427ef70596004a9.png",
          "contentLink": "https://mp.weixin.qq.com/s/_uXqe0ziX20evy_AN2vFLQ",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-10-20T02:13:01.000+00:00",
          "updateTime": "2024-10-22T02:13:01.000+00:00"
        },
        {
          "guid": "1115947061030686737",
          "title": "一种让消费者更信赖企业的调查方式",
          "trendsDesc": " 大人来也平台与用户，在这些年来，共绘成长蓝图，在双向奔赴中见证彼此成长。用户的期待是平台前行的动力，平台的努力则为用户铺设更宽广的道路。在携手共进的路上，我们正在打造一种新的收入模式，希望能持续提供对商家、对用户都有利的多赢格局。\n\n",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-30/image/4dfdb165c81edffde06b316f18aeaefe.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-30/image/5ad16c51ffaec6186337dab3e8f0f348.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-30/image/d5ac9140af4ddc2d9cde1879d0f233d0.png",
          "contentLink": "https://mp.weixin.qq.com/s/IdS8Fmf0LdQS6mn1uU7JFw",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-10-13T01:42:51.000+00:00",
          "updateTime": "2024-10-13T01:42:59.000+00:00"
        },
        {
          "guid": "1115947061030686736",
          "title": "学界专家研讨华米模式实践价值",
          "trendsDesc": "9月29日，以“包容协作治理理论”及华米模式实践价值为主题的研讨会在上海成功举办。来自上海交通大学、浙江大学、华东师范大学、无锡市文广旅游局等高校、政府部门的专家学者、业界代表，共同探讨了包容协作治理理论的缘起、国内外应用现状、华米模式实践成效，结合我国社会特点，对未来发展提出了切实可行的建议。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-04/image/e9d9bbabcf356b5a0a6ab68a465c5d08.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-04/image/626b1b2101a5183df9b18d57902f92e9.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-10-04/image/d57ecb88519be25c3ff355a1b3afb315.png",
          "contentLink": "https://mp.weixin.qq.com/s/ni2Xz8SbXMf2C6RGVpbWbg",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-10-01T15:58:29.000+00:00",
          "updateTime": "2024-10-01T15:58:33.000+00:00"
        },
        {
          "guid": "1115947061030686733",
          "title": "通过体验式调查，实现个人素养提升和企业责任落实",
          "trendsDesc": "近十年来，大人来也通过实名制评估的方式，为企业和政府的数据治理打磨出一块新的拼图。\n\n大人来也不仅是一个为完成调查任务使用的“工具”，也是开展教育的平台。通过参与社会治理，参与者更可以学习到相关法律知识、公共政策和社会规范，也可以了解到企业在经营中的管理标准，从而提升自身的素养和参与能力。\n\n在接单任务前，用户首先要通过任务说明了解该任务的性质、目标。在做出基本判断，且完成接单后，用户还需要在线学习任务要求，“预习”问卷，熟知现场调研操作基本规范。\n\n一位参与过多次企业体验式调查的用户说，现在对服务行业的同理心增强了，因为他知道看似普通的工作，背后有这么多的条条框框，对于一些非恶意的不周到，与其与员工发生冲突，不如心平气和好好沟通。\n\n参与过政务调研项目的用户说，填了几份不同的调研问卷，就看到政府管理中的细致，以前遇到不满意的情况，要么置之不理，私下抱怨，要么就选择投诉。现在看到有些管理部门能主动邀请群众参与体验评价，这个沟通方式更理性，更充分，也令人对这样的部门心生好感。\n\n平台在任务前置设计的培训板块，在某种程度可以被视作组织的宣教引导阵地。例如，一份文旅调研问卷要求“神秘游客”前往游客中心了解相关服务，也相当于推广介绍了游客中心应有的服务，这一部分恰恰是被游客忽略的内容；一家火锅品牌“培训”用户，需要观察锅底是否在点单后5分钟内上桌，这变相地宣传了品牌在出餐效率上的精细化亮点。\n\n平台鼓励机制有助于激发主动意识，无论是通过自身的服务获取酬劳，还是看到提出的建议得到落实，都使组织与个人之间产生良性的互动，更高的黏性。\n\n平台不仅提供参与社会治理的机会，也通过多元化的教育内容和形式，全面提升公民的素养和能力。这种教育与实践相结合的模式，有效地促进了公民的全面发展，为构建知识型、责任型、参与型的现代社会奠定了坚实的基础。通过这样的平台，公民不仅能够更好地参与和影响社会治理，还能够在个人成长和社会进步中找到自己的价值和意义。\n\n与此同时，大人来也为组织提供指引，做好“企业中的第三方”。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/17389423e4af195f7188fdb9f14dd37b.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/d801d0d82b0c5233215f1924c0083e06.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/48828bb95b40b166cb06c31724098158.png",
          "contentLink": "https://mp.weixin.qq.com/s/bJsgCpOOvaSru_MkJRAB6w",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-09-22T03:40:47.000+00:00",
          "updateTime": "2024-09-22T03:40:47.000+00:00"
        },
        {
          "guid": "1115947061030686734",
          "title": "资深评估员线上报名指南",
          "trendsDesc": "【大人来也】资深评估员开始招募啦，各位未来的资深评估员们，想要报名成功，请按照以下的步骤进行线上报名：PART.01完成平台的实名初级认证、PART.02填写【资深评估员报名】问卷、PART.03进入【学习驿站】, 完成培训视频的学习观看、PART.04完成【2024年下半年度资深评估员培训考核问卷】。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/2f64256ffe48add14d1f855b04a7727c.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/eee45dc245dc68fff5d2e136d10ad854.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-23/image/9ed96a98ef83ca3cd58bc8733ca6751e.png",
          "contentLink": "https://mp.weixin.qq.com/s/QVtItUQkvoUd2s_EBVV3pQ",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-09-22T03:40:47.000+00:00",
          "updateTime": "2024-09-22T03:40:47.000+00:00"
        },
        {
          "guid": "1115947061030686732",
          "title": "通过顾客调查形成“陪跑型”伙伴关系",
          "trendsDesc": "我们与数百位品牌经营者、管理者就顾客调查主题做过沟通，大家各有诉求，但也有明确共性，即希望通过顾客的真实反馈——\n\n●帮助企业准确把握市场动态与顾客需求；\n\n●提升品牌知名度、美誉度和忠诚度，增强市场竞争力；\n\n●优化产品服务质量，提高顾客满意度和回头率；\n\n●降低市场风险，为企业稳健发展保驾护航。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-18/image/0c7e41ad73499552a0907fc52e0be091.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-18/image/de915f5a21c4f773112329c60e171d0f.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-18/image/6fe7d3a408a2e7012aea5cbc05ab0fa6.png",
          "contentLink": "https://mp.weixin.qq.com/s/SbLZgFCj3wBdFSrcyvv0bA",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-09-15T05:20:37.000+00:00",
          "updateTime": "2024-09-15T05:20:42.000+00:00"
        },
        {
          "guid": "1115947061030686731",
          "title": "商户端加餐，会员可免费使用“微问卷”",
          "trendsDesc": "大人来也客户在会员权益期内，可以免费使用大人来也商户微问卷啦！\n\n\n\n客户使用“微问卷”，可通过商户端入口进行创建和编辑，依托微信生态，帮助您丰富调查场景。\n\n\n\n“微问卷”既可以成为企业对门店开展组合试测评的有力补充（如何在一个周期内实现组合式门店质量测评），又可以拓展更多的业务需求。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-09/image/31afcfc32c405269eef007769701b9ea.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-09/image/3ed26332585ec99608cda66f6f7fa491.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-09/image/976d481ae519b085658021ea301a65b2.png",
          "contentLink": "https://mp.weixin.qq.com/s/-vExF2l9RZxDE2XGuuUUKw",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-09-08T08:15:12.000+00:00",
          "updateTime": "2024-09-08T08:15:19.000+00:00"
        },
        {
          "guid": "1115947061030686729",
          "title": "资深评估员 持续升级中",
          "trendsDesc": "在我们的“大人”中，有这么一群人——资深评估员。\n\n\n\n我们正式地向您介绍那些在各自领域中发挥着至关重要作用的资深评估员。作为具有高度专业素养与责任感的实名制现场评估专家，他们凭借多年的丰富经验和深厚的知识底蕴，成为了调研行业的佼佼者。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/a35c506fab98f584d60f7035703dc17b.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/a499ec5d6a37b5e64af32377a99e6986.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/d95a82ae3af0586d5b34e34700f89b5f.png",
          "contentLink": "https://mp.weixin.qq.com/s/0xekYCiTM2cVp2lWbiynZw",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-09-01T03:45:53.000+00:00",
          "updateTime": "2024-09-01T03:46:02.000+00:00"
        },
        {
          "guid": "1115947061030686730",
          "title": "操作培训｜异常签到，消费凭证，自带相机，录音",
          "trendsDesc": "随着产品不断升级，【大人来也】将定期为资深评估员提供操作培训，确保平台任务得以高质量完成。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/e343fdeef09d71f525d3f4fcaf720efc.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/d142bf9d68fef59dbc6e50ba5878f6b3.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-09-02/image/6708faa13da68907711297a019711cfc.png",
          "contentLink": "https://mp.weixin.qq.com/s/WXmZMD4igclllFXKR3LX-w",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-09-01T03:45:53.000+00:00",
          "updateTime": "2024-09-01T03:46:02.000+00:00"
        },
        {
          "guid": "1115947061030686728",
          "title": "大人来也在提升消费链路体验中的作用",
          "trendsDesc": "消费链路体验指的是消费者在购买和使用产品或服务过程中所经历的一系列体验环节，或称之客户旅程地图。包括从最初接触产品到最终购买、使用、评价以及可能的复购等全过程。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-26/image/096a4d94f5a66f92135b4e9ac6913ff5.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-26/image/2f59b3d491076aacad55620f40f9df4a.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-26/image/a9141cbaec5675080685079267a46c8a.png",
          "contentLink": "https://mp.weixin.qq.com/s/YWwu3nezS0w0fNogUAg0CA",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-08-25T02:00:52.000+00:00",
          "updateTime": "2024-08-25T02:00:57.000+00:00"
        },
        {
          "guid": "1115947061030686727",
          "title": "如何在一个周期内实现组合式门店质量测评",
          "trendsDesc": "连锁企业的竞争力在于标准化、可复制，但表象上的统一，背后却不是“一刀切”的管理模式。每家企业都有自己的独门心法，包括组织结构、运营流程、商品服务、店铺管理、销售、库存、结算、品类管理和顾客服务等。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-19/image/0fee3ee67a5f8592c8670cf3cf99d9c4.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-19/image/e4b8e9d57cb0c2fb01dd8f2cc6850405.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-19/image/eb4d77acd19fd88a2dad76dcf3370b0f.png",
          "contentLink": "https://mp.weixin.qq.com/s/C9VejOsnP0JkQ2mxFSeXrw",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-08-18T05:17:32.000+00:00",
          "updateTime": "2024-08-18T05:17:32.000+00:00"
        },
        {
          "guid": "1115947061030686726",
          "title": "想要少花力气删差评，不如“灭差”练真功",
          "trendsDesc": "在社交媒体时代，几乎所有商家都有“口碑焦虑”，一方面面对差评心急如焚，一方面又使出十八般武艺攒好评。面对这样的“双重困境”，奇葩操作也不罕见，雇水军刷好评或许只是多花钱，利用不正当手段“删差评”则有可能违反《消费者权益保护法》相关规定，被视为损害消费者的知情权、选择权和公平交易权。\n\n",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-13/image/add0870d202b8a231e79dbc4bd2c439b.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-13/image/6f8f677869bb4e19f0172f2f2be3c501.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-13/image/f155a5d11741e61b1067a79146490ed4.png",
          "contentLink": "https://mp.weixin.qq.com/s/yeUxPAzQtDx9iHxJyecqiA",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-08-11T05:17:32.000+00:00",
          "updateTime": "2024-08-11T05:17:32.000+00:00"
        },
        {
          "guid": "1115947061030686725",
          "title": "短平快！让询价不再影响决策的效率",
          "trendsDesc": "老板说，要找第三方开展神秘顾客调查、要开展顾客满意度调查、要做市场洞察、要获客……\n我问老板，预算多少？\n老板说，你先了解一下市场行情，找一些报价来。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-01/image/733c4d0ffbd70d36cb3ece1ac9008ba0.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-01/image/736be1640e2cdbf377ac1bef86a32fc7.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-01/image/c87d1b6a744e79024f75abb0fde1de5b.png",
          "contentLink": "https://mp.weixin.qq.com/s/lFf9hR7-0yTJRUErziedEg",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-08-04T05:04:46.000+00:00",
          "updateTime": "2024-08-04T05:04:46.000+00:00"
        },
        {
          "guid": "1115947061030686723",
          "title": "满意度？态度？你到底要了解什么？",
          "trendsDesc": "我们绝大多数人都收到过顾客满意度的调查问卷，有现场填写纸质的、Email发来的、登入网站的、扫描二维码的、App里的，讲究点的，还有电话访问和面对面访谈。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-01/image/5d4acfde6daf757e7d154c0c1a563fb9.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-01/image/b118a71a508ce96c10fbf8b117d3e7b2.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-01/image/6cab76ce0b3ebc9f8679f0d4e1078a8e.png",
          "contentLink": "        <div class=\"blank_row\"></div>\n        <div class=\"h1\">满意度？态度？你到底要了解什么？</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">\n          我们绝大多数人都收到过顾客满意度的调查问卷，有现场填写纸质的、Email发来的、登入网站的、扫描二维码的、App里的，讲究点的，还有电话访问和面对面访谈。\n        </div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">顾客满意度是服务业最为重视的评价体系之一，企业发起满意度调研，通常有以下几个理由：</div>\n        <ul>\n          <li class=\"text\">了解消费者是否认可本企业的产品和服务；</li>\n          <li class=\"text\">了解消费者产生复购的动力；</li>\n          <li class=\"text\">为产品和服务的调整提供决策依据；</li>\n          <li class=\"text\">提升消费者的忠诚度；</li>\n          <li class=\"text\">通过负面评价建立预警。</li>\n        </ul>\n        <div class=\"text\">最终目标，提升消费者满意度。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">看似简单的评价逻辑，促生了许多大生意。最直接的如点评网站，海量点评早已超出满意度的范畴，亲历者生产内容的模式，逐渐建立起一套民间信用体系，这套体系影响着消费者的选择，也促使有商业头脑的商家把大量精力投入到体验式和评价营销上。评价造就了企业与消费者之间的互动式生存方式，这在以往没有移动互联网的时代是不可想象的。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">我们知道这是一门好生意，企业也希望有越来越多的第三方工具可以运用。其中有一个核心价值——企业希望了解的内容，与其说是满意度，不如说是态度。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">通过一次与消费者的“深度”交流，获取具有价值的态度，这是一个非常宝贵的机会。如果把控好这个机会，消费者就有可能与你建立粘性，反之，则进一步推远了消费者。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">如何把控这次机会呢？我们从形式和内容两个方面来看。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">从形式上看，传统的满意度调研往往激发不了消费者的兴趣。为什么呢？因为消费者不愿意多花时间。懒人经济的时代，人们巴不得把衣食住行都外包掉，还有多少消费者愿意填写一份问卷呢？所以，要鼓励消费者反馈满意度，就必须要让他们感受到这个行为能带来回报，回报可以是物质上的，也可以是精神上的。所以我们通常看到有些企业会给填写问卷的消费者予以折扣或者积分上的奖励。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\"> 从内容上看，调研问卷最常见的是给各项品质打分，然后问一下意见和建议。这种形式的接受度相当高，也不需要消费者有什么特殊的技能。但相应的，这个过程是无趣的，如果问卷的题量一旦多了，消费者就不情愿了。企业也会想当然地认为，题量和信息量成正比。所以满意度调研的信息量通常不会太大。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">针对以上形式和内容的两类特点，我们在设计调研产品的时候，就一直在评估整个行为逻辑的合理性。每家企业的需求都是点面结合，立体丰满的。出于管理的方便，企业通常会按职能做内部切分，比如市场部、督导部、合规部等，都是独立条线，职责分明。然而，如今企业与消费者交互的方式正在发生极大变化，传统一次性的交易可能变成不断交互，线下体验可能与线上交互持续地结合，企业都在追求不断地“到达”，有效地“到达”。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">再回过来看传统的满意度调研，这个行为本身显得有点out了。所以我们设想了这样一个场景：A先生因为想要参与一个体验式调研，所以来到了餐厅，在门店里，他带着调研的要求，观察、体验、挑战、记录。最后，他在移动端把调研反馈信息一键传送给了企业，他心满意足地离开了，这一餐打了个实实在在的折扣。回去以后，他还把这段有趣的经历分享给了同事。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">A先生光临的这家餐厅，在问卷里问到的内容，包括了产品和服务的品质，还有对促销活动力度的评价。对于A先生自发的点餐倾向，买单方式，餐厅也做了观察和记录。最后，还询问了A先生的年龄段、收入和工作。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">事实上，这家餐厅每个月都在持续地通过调研“邀请”各种A先生到店，并不断调整着产品和服务要求。有意思的是，A先生们不仅自己成为老顾客，还带了越来越多的人到店。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">企业在每个阶段都有不同需求，不同管理部门也有自己的专业想法，大人来也在服务这些企业的时候，始终认为企业管理者才是这家企业最称职的专家，他们设计的调研最能符合企业的需求。而我们，则在解读答案和数据时，帮助管理者们一层一层“剥洋葱”。剥开了洋葱，才能看到真实消费者的真实态度。</div>\n        <div class=\"blank_row\"></div>",
          "tag": "1",
          "type": "4",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-08-01T04:58:51.000+00:00",
          "updateTime": "2024-08-01T04:58:54.000+00:00"
        },
        {
          "guid": "1115947061030686724",
          "title": "那些永远不达标的标准，还要保留么？",
          "trendsDesc": "每家连锁餐饮或零售企业在做员工考核时，都设立了一套完整详细的标准，它们往往细化到每个小动作，举个例子——带领顾客入座过程中，随时确认顾客是否跟上。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-01/image/ebc8656425360b376fd8618c21ff3c78.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-01/image/c01990171062c3f90cbb49ade86f5dbf.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-08-01/image/ebe7db1b1e4c74747d7f448f07ce1af0.png\n",
          "contentLink": "        <div class=\"blank_row\"></div>\n        <div class=\"h1\">那些永远不达标的标准，还要保留么？</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">\n          每家连锁餐饮或零售企业在做员工考核时，都设立了一套完整详细的标准，它们往往细化到每个小动作，举个例子——带领顾客入座过程中，随时确认顾客是否跟上。\n        </div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">这些指南型标准，是企业结合业务需求和行业基本标准制定的。员工培训的一项重要内容，就是确保每个人了解、熟悉并且遵照标准执行。管理层认为，只要能百分百跟着标准实施，一定能把服务和品质保证在高分段。</div>\n\n        <div class=\"text\">有趣的是，几乎每个客户的操作手册中，都至少有一项“永远没人能做好”的标准。那条几乎全部人都会被扣分的标准，渐渐就变得谁都不重视了。我们称它为“第22条标准”（源自“第二十二条军规”）。</div>\n        <div class=\"blank_row\"></div>\n\n        <div class=\"text\">既然人人都扣分，为什么你们还保留它？又或者，为什么你们不去努力做好？</div>\n        <div class=\"blank_row\"></div>\n\n        <div class=\"text\">“第22条标准”，去掉它，还是保留它？</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\"><strong>去掉它</strong>——标准本身不具可操作性，果断去掉，或者修改。例如某柜台点餐型餐厅，要求点餐员主动向顾客推荐规定菜品。点餐员碰到的困难有两类，一是高峰时段点餐效率要求很高，二是很多常客往往一上来就报出自己要的菜品，缺乏推荐时机，即使推荐，接受度也不高，更有可能因效率下降引发反感，延长点餐时间。如果你站在点餐柜台旁边观察10位顾客，其中有至少一半都无需推荐，剩下的一半顾客，更需要的是对某类他感兴趣的产品的解释。因此，对于这条标准，我们建议改为</div>\n        <div class=\"text\">“当顾客犹豫3秒以上时，主动推荐菜品；当顾客询问具体产品时，第一时间正确回答”。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\"><strong>保留它</strong>——标准本身具有可操作性，且是企业文化的组成部分，那就以达标为最终目的，从过程中改变。例如某餐厅，要求所有与顾客打照面的服务员都要暂时停下脚步问好。但到了忙时，服务员一刻不停，经常注意不到顾客。当他们因为标准不达标被扣分时，常觉委屈，认为自己已经努力工作，并未偷懒。对于这种情况，企业要从改变员工的意识入手，在培训中让他们明白向顾客问好的意义，使员工发自内心认同一句简单问好的价值。其次再培训技巧，优化流程。</div>\n        <div class=\"blank_row\"></div>\n        <div class=\"text\">标准是死的，人是活的。调研可以帮助企业理顺流程，进一步走向精益管理。所以需要就调研结果反复评估，找到共性难点。最终，是让标准为人服务，而不是人被标准牵着鼻子走。</div>\n        <div class=\"blank_row\"></div>",
          "tag": "1",
          "type": "4",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-08-01T04:58:51.000+00:00",
          "updateTime": "2024-08-01T04:58:54.000+00:00"
        },
        {
          "guid": "1115947061030686720",
          "title": "加盟总部一边“喂客户”给加盟门店，一边完成对门店评估",
          "trendsDesc": "加盟商做着做着，会不会把我的客户转化为他自己的客户？\n加盟店铺会不会因为经营不规范，砸了我目前还有点脆弱的牌子？",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-07-25/image/56c42863b428afdf361c2d8ffec56770.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-07-25/image/5d58463edc2674595d1e2c670182bded.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-07-25/image/971e82090eee9582238a6ef91e926efc.png",
          "contentLink": "https://mp.weixin.qq.com/s/HauZo8O7htSQoOlZa9kIPQ",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-07-28T07:22:39.000+00:00",
          "updateTime": "2024-07-28T07:22:42.000+00:00"
        },
        {
          "guid": "1115947061030686722",
          "title": "只花了7500元，就带来43组顾客到店消费，还完成门店评估？",
          "trendsDesc": "门店“失控”，危机公关成本大？\n信息不对称，无法全面掌握一手信息，影响判断？\n对一线的考评缺乏扎实依据，影响员工满意度？\n内部督导“脸熟”，看不到真相？\n以上是企业商户面临管理门店的共同难题。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-07-26/image/e0930f1e8e0a62fd27ad204f13939600.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-07-26/image/48c30b391295dfe326d65d3834d15606.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-07-26/image/10160d90b2a814e88d9d97cd39824aa5.png",
          "contentLink": "https://media.darenlaiye.com/guanwang_video/1115947061030686722.mp4",
          "tag": "1",
          "type": "3",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-07-26T08:19:00.000+00:00",
          "updateTime": "2024-07-26T08:19:04.000+00:00"
        },
        {
          "guid": "1115947061030686721",
          "title": "开店，与顾客建立安全的联系",
          "trendsDesc": "“请给一个好评，送您一份饮料。”\n“请发一条笔记，送您一个小菜。”\n“打卡上传，@我们，即可获得一张八折券。”\n心大而又懒惰的顾客，甚至把手机交给店员，直接现场创作。\n以上这些操作，无论是顾客，还是经营者，是否觉得很熟悉？\n我们对社交媒体的能量又爱又恨，如果可以，每一位经营者都希望能与顾客建立一个更安全、更真诚的联络途径。",
          "headImage": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-07-25/image/00ed707015fa9a56e45d12258977b9ce.png",
          "headImageMax": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-07-25/image/ddf3b6ae6a2c61220622e609e3f9a090.png",
          "headImageMin": "https://huami-merchant.oss-cn-hangzhou.aliyuncs.com/merchant-upload/2024-07-25/image/e599e5aa1b7ccb062999015c0d5fbb5e.png",
          "contentLink": "https://mp.weixin.qq.com/s/ou8JkepSd2Qm1JIJbsGFmg",
          "tag": "1",
          "type": "1",
          "optStatus": 1,
          "isDelete": 0,
          "createTime": "2024-07-21T07:23:01.000+00:00",
          "updateTime": "2024-07-21T07:23:06.000+00:00"
        }
      ],
    };
  },
  watch: {},
  computed: {
    baseUrl() {
      if (location.href.indexOf("www.darenlaiye.com") > 0) {
        return "https://e.darenlaiye.com/application/api";
      }
      return "https://e_test.darenlaiye.com/application/api";
    },
  },
  methods: {
    getTrendsData() {
      this.requestApi("admin.drly.company.website.drly.trends.list.gw", {})
        .then((resp) => {
          this.trendsData = resp.data.list;
        })
        .catch((err) => { })
        .finally(() => { });
    },

    requestApi(actions, params) {
      params.platform = "guanwang";
      return new Promise((resolve, reject) => {
        fetch(`${this.baseUrl}?action=${actions}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ params: params }),
        })
          .then((response) => response.json()) // 如果服务器返回JSON，则解析它
          .then((resp) => {
            if (resp.code == 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          }) // 处理服务器返回的数据
          .catch((error) => {
            reject(error);
          }); // 处理错误
      });
    },
    clickTag(ac) {
      this.active = ac;
    },
    getTagText(tag) {
      if (tag == 1) {
        return "宣传推广";
      }
      return "";
    },
  },
  created() { },
  mounted() {
    this.trendsData = [];
    this.getTrendsData();
  },
};
</script>
<style lang='less' scoped>
/* 特定于桌面的样式 */
@media screen and (min-width: 1280px) {
  .drlyTrends {
    background-color: #fff;
    .headImg {
      height: 300px;
      .head_body {
        width: calc(100% - 40px);
        padding: 0px 20px;
        max-width: 1280px;
        margin: 0px auto;
        padding-top: 80px;
        height: calc(100% - 80px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .head_title {
          font-size: 2.5rem;

          font-weight: bolder;
          color: #111925;
        }
        img {
          height: 200px;
        }
      }
    }
    .body {
      width: calc(100% - 40px);
      padding: 0px 20px;
      max-width: 1280px;
      margin: 0px auto;
      display: flex;
      justify-content: space-between;
      .menu {
        width: 148px;
        height: 318px;
        position: sticky;
        margin-top: 20px;
        top: 100px;
        .menu_item {
          text-align: center;
          border-radius: 0.375rem;
          font-size: 0.875rem;
          height: 2.25rem;
          width: 9.25rem;
          cursor: pointer;
          margin-top: 12px;
          line-height: 2.25rem;
          color: #111925;
          background-color: #f3f3f3;
          font-weight: 400;
        }
        .active {
          background-color: #ff715f;
        }
      }
      .content {
        margin-top: 20px;
        width: calc(100% - 208px);
      }
    }
  }
}

/* 特定于移动设备的样式 */
@media screen and (max-width: 1279px) {
  .drlyTrends {
    background-color: #fff;
    .headImg {
      height: 300px;
      .head_body {
        width: calc(100% - 40px);
        padding: 0px 20px;
        max-width: 1280px;
        margin: 0px auto;
        padding-top: 80px;
        height: calc(100% - 80px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .head_title {
          font-size: 2.5rem;

          font-weight: bolder;
          color: #111925;
        }
        img {
          height: 200px;
        }
      }
    }
    .body {
      width: calc(100% - 40px);
      padding: 0px 20px;
      max-width: 1280px;
      margin: 0px auto;
      display: flex;
      justify-content: space-between;
      .menu {
        width: 148px;
        height: 318px;
        position: sticky;
        margin-top: 20px;
        top: 100px;
        .menu_item {
          text-align: center;
          border-radius: 0.375rem;
          font-size: 0.875rem;
          height: 2.25rem;
          width: 9.25rem;
          cursor: pointer;
          margin-top: 12px;
          line-height: 2.25rem;
          color: #111925;
          background-color: #f3f3f3;
          font-weight: 400;
        }
        .active {
          background-color: #ff715f;
        }
      }
      .content {
        margin-top: 20px;
        width: calc(100% - 208px);
      }
    }
  }
}

/* 特定于移动设备的样式 */
@media screen and (max-width: 1024px) {
  .drlyTrends {
    background-color: #fff;
    .headImg {
      height: 186px;
      .head_body {
        width: calc(100% - 40px);
        padding: 0px 20px;
        max-width: 1280px;
        margin: 0px auto;
        padding-top: 80px;
        height: calc(100% - 80px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .head_title {
          font-size: 1.25rem;
          font-weight: bolder;
          color: #111925;
        }
        img {
          height: 100px;
        }
      }
    }
    .body {
      width: calc(100% - 40px);
      padding: 0px 20px;
      max-width: 1280px;
      margin: 0px auto;
      .menu {
        width: 148px;
        height: 318px;
        position: sticky;
        margin-top: 20px;
        top: 100px;
        display: none;
        .menu_item {
          text-align: center;
          border-radius: 0.375rem;
          font-size: 0.875rem;
          height: 2.25rem;
          width: 9.25rem;
          cursor: pointer;
          margin-top: 12px;
          line-height: 2.25rem;
          color: #111925;
          background-color: #f3f3f3;
          font-weight: 400;
        }
        .active {
          background-color: #ff715f;
        }
      }
      .content {
        margin-top: 20px;
        width: calc(100% - 0px);
      }
    }
  }
}
</style>